// ============================================
// МОДАЛЬНОЕ ОКНО (ОБРАТНЫЙ ЗВОНОК) - БЕЗ ИМЕНИ
// ============================================
document.addEventListener('DOMContentLoaded', function() {
    const modal = document.getElementById('callbackModal');
    const closeBtn = document.getElementById('closeModal');
    const openButtons = document.querySelectorAll('.open-modal');
    const form = document.getElementById('callbackForm');
    const phoneInput = document.getElementById('phoneInput');
    const policyCheck = document.getElementById('policyCheck');
    const body = document.body;

    if (!modal) return;

    // ===== АВТОМАТИЧЕСКАЯ МАСКА ТЕЛЕФОНА =====
    if (phoneInput) {
        function maskPhone(value) {
            let numbers = value.replace(/\D/g, '');
            if (numbers.length > 11) numbers = numbers.slice(0, 11);
            let formatted = '';
            if (numbers.length > 0) {
                formatted = '+7';
                if (numbers.length > 1) formatted += ' (' + numbers.slice(1, 4);
                if (numbers.length > 4) formatted += ') ' + numbers.slice(4, 7);
                if (numbers.length > 7) formatted += '-' + numbers.slice(7, 9);
                if (numbers.length > 9) formatted += '-' + numbers.slice(9, 11);
            }
            return formatted;
        }

        phoneInput.addEventListener('input', function(e) {
            let cursorPos = e.target.selectionStart;
            let oldLength = e.target.value.length;
            let newValue = maskPhone(e.target.value);
            e.target.value = newValue;
            let newLength = newValue.length;
            let diff = newLength - oldLength;
            e.target.setSelectionRange(cursorPos + diff, cursorPos + diff);
        });

        // При фокусе добавляем +7
        phoneInput.addEventListener('focus', function() {
            if (this.value.trim() === '' || this.value === '+7') {
                this.value = '+7';
                setTimeout(() => {
                    this.setSelectionRange(2, 2);
                }, 0);
            }
        });

        // Клик для установки курсора
        phoneInput.addEventListener('click', function() {
            if (this.value === '+7') {
                this.setSelectionRange(2, 2);
            }
        });
    }

    // ===== ФУНКЦИЯ ПОКАЗА УВЕДОМЛЕНИЯ =====
    function showNotification(message, type = 'error') {
        const existingToast = document.querySelector('.custom-toast');
        if (existingToast) existingToast.remove();

        const toast = document.createElement('div');
        toast.className = `custom-toast custom-toast--${type}`;
        toast.textContent = message;
        document.body.appendChild(toast);

        setTimeout(() => toast.classList.add('show'), 10);
        setTimeout(() => {
            toast.classList.remove('show');
            setTimeout(() => toast.remove(), 300);
        }, 3000);
    }

    // ===== ВАЛИДАЦИЯ ТЕЛЕФОНА =====
    function validatePhone(phone) {
        const numbers = phone.replace(/\D/g, '');
        return numbers.length >= 11;
    }

    // ===== ОТКРЫТИЕ МОДАЛЬНОГО ОКНА =====
    function openModal(e) {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        modal.classList.add('active');
        body.classList.add('no-scroll');
    }

    // ===== ЗАКРЫТИЕ МОДАЛЬНОГО ОКНА =====
    function closeModal() {
        modal.classList.remove('active');
        body.classList.remove('no-scroll');
        if (form) form.reset();
        if (phoneInput) phoneInput.value = '+7';
    }

    // Обработчики открытия
    if (openButtons.length) {
        openButtons.forEach(btn => btn.addEventListener('click', openModal));
    }

    // Обработчики закрытия
    if (closeBtn) {
        closeBtn.addEventListener('click', closeModal);
    }

    // Закрытие по клику вне окна
    modal.addEventListener('click', function(e) {
        if (e.target === modal) closeModal();
    });

    // Закрытие по Escape
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && modal.classList.contains('active')) closeModal();
    });

    // ===== ОТПРАВКА ФОРМЫ =====
    if (form) {
        form.addEventListener('submit', function(e) {
            e.preventDefault();

            const phone = phoneInput ? phoneInput.value.trim() : '';
            const isPolicyChecked = policyCheck ? policyCheck.checked : false;

            // Валидация телефона
            if (!validatePhone(phone)) {
                showNotification('Введите корректный номер телефона', 'warning');
                phoneInput?.focus();
                return;
            }

            // Валидация согласия
            if (!isPolicyChecked) {
                showNotification('Подтвердите согласие с политикой', 'warning');
                policyCheck?.focus();
                return;
            }

            // Блокируем кнопку
            const submitBtn = form.querySelector('.modal__submit');
            const originalText = submitBtn ? submitBtn.textContent : 'Отправить';
            if (submitBtn) {
                submitBtn.textContent = 'Отправка...';
                submitBtn.disabled = true;
            }

            // Отправляем только цифры
            const phoneNumbers = phone.replace(/\D/g, '');

            // Отправка данных
            const formData = new URLSearchParams({
                action: 'takt_submit_modal_form',
                nonce: takt_ajax.nonce,
                phone: phoneNumbers
            });

            fetch(takt_ajax.ajax_url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: formData
            })
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    window.location.href = '/thanks/';
                } else {
                    showNotification(data.data || 'Произошла ошибка. Попробуйте ещё раз.', 'error');
                    if (submitBtn) {
                        submitBtn.textContent = originalText;
                        submitBtn.disabled = false;
                    }
                }
            })
            .catch(error => {
                console.error('Ошибка:', error);
                showNotification('Ошибка соединения. Проверьте интернет.', 'error');
                if (submitBtn) {
                    submitBtn.textContent = originalText;
                    submitBtn.disabled = false;
                }
            });
        });
    }
});
